export default __webpack_public_path__ + "static/media/hero.460a4b74.svg";